import "./styles.css";
import Header from "./components/header";
import Home from "./components/home";

export default function App() {
  return (
    <>
      <Header />
      <Home />
    </>
  );
}
